import React from 'react';
import styled from 'styled-components';

const LogoContainer = styled.div<{ size?: number }>` 
  display: block;
  width: ${props => props.size || 80}px;
  height: ${props => props.size || 80}px;
  margin: 0 auto 1rem auto;
`;const LogoSvg = styled.svg`
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
`;

interface EventosHubFaviconProps {
  size?: number;
}

export const EventosHubFavicon: React.FC<EventosHubFaviconProps> = ({ size = 300 }) => {
  return (
    <LogoContainer size={size}>
      <LogoSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
        <defs>
          <linearGradient id="favicon-gradient" x1="0" x2="1">
            <stop offset="0" stopColor="#6B7BFF"/>
            <stop offset="1" stopColor="#3B3FE0"/>
          </linearGradient>
        </defs>
        <circle cx="64" cy="64" r="64" fill="url(#favicon-gradient)" />
        <text x="64" y="78" font-family="Inter, sans-serif" font-weight="800" font-size="32" fill="#fff" text-anchor="middle">EH</text>
      </LogoSvg>
    </LogoContainer>
  );
};